var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QCard',{class:[
    'login-card column',
    { 'full-height': _vm.flat, 'full-width': _vm.fullWidth }
  ],attrs:{"flat":_vm.flat}},[_c('QCardSection',{class:{ 'q-pa-lg': _vm.flat }},[(_vm.$slots.header)?_c('div',{class:[
        'q-mb-lg row justify-between items-center',
        { 'q-mt-md': !_vm.flat }
      ]},[_vm._t("header"),(_vm.$listeners.close)?_c('QBtn',{attrs:{"icon":"eva-close-outline","color":"grey-8","round":"","flat":"","dense":"","ripple":false,"size":"12px"},on:{"click":function($event){return _vm.$emit('close', $event)}}}):_vm._e()],2):_vm._e(),_vm._t("default")],2),_c('QSpace'),(_vm.$slots.footer)?_c('QCardActions',{staticClass:"q-pa-md bdr-t-grey-3 column justify-center"},[_vm._t("footer")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }